import { render, staticRenderFns } from "./ApiCallPlaceholder.vue?vue&type=template&id=74c06e24&scoped=true&"
import script from "./ApiCallPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ApiCallPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ApiCallPlaceholder.vue?vue&type=style&index=0&id=74c06e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c06e24",
  null
  
)

export default component.exports